var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import React from 'react';
import ViewNavigation from '../components/ViewNavigation';
var YearsView = /** @class */ (function (_super) {
    __extends(YearsView, _super);
    function YearsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledYearsCache = {};
        _this._updateSelectedYear = function (event) {
            _this.props.updateDate(event);
        };
        return _this;
    }
    YearsView.prototype.render = function () {
        return (_jsxs("div", { className: "rdtYears", children: [_jsx("table", { children: _jsx("thead", { children: this.renderNavigation() }) }), _jsx("table", { children: _jsx("tbody", { children: this.renderYears() }) })] }));
    };
    YearsView.prototype.renderNavigation = function () {
        var _this = this;
        var viewYear = this.getViewYear();
        return (_jsx(ViewNavigation, { onClickPrev: function () { return _this.props.navigate(-10, 'years'); }, onClickSwitch: function () { return _this.props.showView('years'); }, onClickNext: function () { return _this.props.navigate(10, 'years'); }, switchContent: "".concat(viewYear, "-").concat(viewYear + 9) }));
    };
    YearsView.prototype.renderYears = function () {
        var viewYear = this.getViewYear();
        // 12 years in 3 rows for every view
        var rows = [[], [], []];
        for (var year = viewYear - 1; year < viewYear + 11; year++) {
            var row = getRow(rows, year - viewYear);
            row.push(this.renderYear(year));
        }
        return rows.map(function (years, i) { return _jsx("tr", { children: years }, i); });
    };
    YearsView.prototype.renderYear = function (year) {
        var selectedYear = this.getSelectedYear();
        var className = 'rdtYear';
        var onClick;
        if (this.isDisabledYear(year)) {
            className += ' rdtDisabled';
        }
        else {
            onClick = this._updateSelectedYear;
        }
        if (selectedYear === year) {
            className += ' rdtActive';
        }
        var props = { key: year, className: className, 'data-value': year, onClick: onClick };
        return this.props.renderYear(props, year, this.props.selectedDate && this.props.selectedDate.clone());
    };
    YearsView.prototype.getViewYear = function () {
        return parseInt(this.props.viewDate.year() / 10, 10) * 10;
    };
    YearsView.prototype.getSelectedYear = function () {
        return this.props.selectedDate && this.props.selectedDate.year();
    };
    YearsView.prototype.isDisabledYear = function (year) {
        var cache = this.disabledYearsCache;
        if (cache[year] !== undefined) {
            return cache[year];
        }
        var isValidDate = this.props.isValidDate;
        if (!isValidDate) {
            // If no validator is set, all days are valid
            return false;
        }
        // If one day in the year is valid, the year should be clickable
        var date = this.props.viewDate.clone().set({ year: year });
        var day = date.endOf('year').dayOfYear() + 1;
        while (day-- > 1) {
            if (isValidDate(date.dayOfYear(day))) {
                cache[year] = false;
                return false;
            }
        }
        cache[year] = true;
        return true;
    };
    YearsView.defaultProps = {
        renderYear: function (props, year) { return _jsx("td", __assign({}, props, { children: year })); },
    };
    return YearsView;
}(React.Component));
export default YearsView;
function getRow(rows, year) {
    if (year < 3) {
        return rows[0];
    }
    if (year < 7) {
        return rows[1];
    }
    return rows[2];
}
